<aside class="sidenav" cdkTrapFocus [cdkTrapFocusAutoCapture]="true" >
    <div class="sidenav-header" [tabIndex]="0"
         [attr.aria-label]="('SCREEN_READER.MENU_OPEN' | translate) + (title$ | async)">
        <p class="sidenav-header__title">{{title$ | async}}</p>
        <app-button *ngIf="!hideCloseIcon"
                    [ariaLabel]="('GENERAL.CLOSE' | translate) + ('GENERAL.MENU' | translate) + ('GENERAL.BUTTON' | translate)"
                    [cssClasses]="'icon'"
                    [icon]="'close'"
                    [iconColor]="'gray-08'"
                    (buttonClicked)="closeEvent.emit($event)">
        </app-button>
    </div>
    <div class="sidenav-content">
        <app-display-consent-outline *ngIf="openMenu === outlineEnum"
                                     [attr.aria-expanded]="true"
                                     [treeData]="treeData"
                                     [currentUnitOrderId]="currentUnitOrderId"
                                     [listClickable]="reviewerMode"
                                     [comments]="comments"
                                     [scrollIntoViewFeature]="!reviewerMode"
                                     (emitClickedElement)="showElementEvent.emit($event)"
                                     (emitUnderstoodItemClickedEvent)="displayUnderstoodUnitAgainEvent.emit($event)">
        </app-display-consent-outline>

        <app-display-consent-comments *ngIf="openMenu === commentsEnum && (enableCommenting || reviewerMode)"
                                      [sideMenuOpen]="sideMenuOpen"
                                      [hideButtonActionsForReviewer]="reviewerMode"
                                      [comments]="comments"
                                      (editEvent)="editCommentEvent.emit($event)"
                                      (deleteEvent)="deleteCommentEvent.emit($event)"
                                      (addCommentEvent)="addCommentEvent.emit($event)"
                                      (pauseAudioEvent)="pauseAudioEvent.emit()">
        </app-display-consent-comments>

        <app-display-consent-settings *ngIf="openMenu === settingsEnum"
                                      [textSize]="textSize"
                                      (sliderChangeEvent)="sliderChange($event)">
        </app-display-consent-settings>

    </div>
</aside>
